export function resolveEffectiveRepaymentPeriods(state, hillModel, useHillRoas) {
  const baseLength = useHillRoas
    ? hillModel.maxRoasByMob.length
    : state.roas.length;
  const override = state.numberOfRepayments;
  if (override != null && Number(override) > 0) {
    return Math.max(1, Math.floor(Number(override)));
  }
  return Math.max(1, baseLength);
}

export function applyRepaymentPeriodLimit(cumulativeRoas, maxRepaymentPeriods) {
  const roas = [...(cumulativeRoas || [])];
  const periods = Math.max(1, maxRepaymentPeriods ?? roas.length);
  if (periods < roas.length) {
    return roas.slice(0, periods);
  }
  return roas;
}
